module.exports = __webpack_public_path__ + "static/media/item_2_12_comp.269d2593.png";